var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-autonumeric',{staticClass:"input is-small",staticStyle:{"text-align":"right","background-color":"#FFF3A3"},attrs:{"disabled":_vm.disabled,"input":_vm.input,"options":_vm.currency,"readonly":_vm.readonly},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }